import {
	AppBar,
	Box,
	Divider,
	IconButton,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Popover,
	SvgIcon,
	Toolbar,
	Typography
} from '@mui/material'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { orange } from '@mui/material/colors'
import { styled } from '@mui/styles'
import {
	BarsFal,
	SignOutAltFal,
	UserCircleFas
} from '@oliverit/react-fontawesome'
import { t } from 'i18next'

const drawerWidth = 280

const sx = {
	flex: {
		flexGrow: 1
	},
	menuButton: {
		marginLeft: (theme) => theme.spacing(-1.5),
		marginRight: (theme) => theme.spacing(2.5)
	},
	appBar: {
		zIndex: (theme) => theme.zIndex.drawer + 1,
		transition: (theme) =>
			theme.transitions.create(['width', 'margin'], {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen
			})
	},
	appBarShift: {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: (theme) =>
			theme.transitions.create(['width', 'margin'], {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.enteringScreen
			})
	},
	hide: {
		display: 'none'
	}
}

const StyledAppBar = styled(AppBar)(({ theme }) => ({
	height: theme.getToolbarMinHeight('sm')
}))

class TopBar extends PureComponent {
	static propTypes = {
		fullName: PropTypes.string.isRequired,
		isSideMenuOpen: PropTypes.bool.isRequired,
		logout: PropTypes.func.isRequired,
		showSideMenu: PropTypes.func.isRequired,
		title: PropTypes.string
	}

	state = {
		isAccountInfoOpen: false,
		anchorEl: null
	}

	handleShowAccountInfo = (event) => {
		this.setState({
			isAccountInfoOpen: true,
			anchorEl: event.currentTarget
		})
	}

	handleHideAccountInfo = () => {
		this.setState({
			isAccountInfoOpen: false,
			anchorEl: null
		})
	}

	render() {
		const { logout, fullName, isSideMenuOpen, showSideMenu, title } = this.props
		const { anchorEl, isAccountInfoOpen } = this.state

		const appBarStyle = isSideMenuOpen
			? { ...sx.appBar, ...sx.appBarShift }
			: sx.appBar
		const iconButtonStyle = isSideMenuOpen
			? { ...sx.menuButton, ...sx.hide }
			: sx.menuButton

		let environmentBox
		if (
			process.env.REACT_APP_ENVIRONMENT &&
			process.env.REACT_APP_ENVIRONMENT !== 'production'
		) {
			environmentBox = (
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						backgroundColor: orange[500],
						height: (theme) => theme.getToolbarMinHeight('sm'),
						px: 1
					}}
				>
					<Typography
						sx={{
							color: (theme) => theme.palette.common.white
						}}
					>
						{process.env.REACT_APP_ENVIRONMENT.toUpperCase()}
					</Typography>
				</Box>
			)
		}

		return (
			<StyledAppBar position="absolute" sx={appBarStyle}>
				<Toolbar>
					<IconButton
						sx={iconButtonStyle}
						color="inherit"
						onClick={showSideMenu}
						size="large"
					>
						<SvgIcon>
							<BarsFal />
						</SvgIcon>
					</IconButton>
					<Typography variant="h6" color="inherit" sx={sx.flex}>
						{title}
					</Typography>
					<IconButton
						color="inherit"
						onClick={this.handleShowAccountInfo}
						size="large"
					>
						<SvgIcon>
							<UserCircleFas />
						</SvgIcon>
					</IconButton>
					<Popover
						open={isAccountInfoOpen}
						onClose={this.handleHideAccountInfo}
						anchorEl={anchorEl}
						anchorOrigin={{
							vertical: 'top',
							horizontal: 'right'
						}}
						transformOrigin={{
							vertical: 'top',
							horizontal: 'right'
						}}
					>
						<List dense>
							<ListItem>
								<ListItemText>
									<Typography variant="subtitle1">{fullName}</Typography>
								</ListItemText>
							</ListItem>
							<Divider />
							<Divider />
							<ListItem button onClick={logout}>
								<ListItemIcon>
									<SvgIcon>
										<SignOutAltFal />
									</SvgIcon>
								</ListItemIcon>
								<ListItemText primaryTypographyProps={{ variant: 'body2' }}>
									{t('app:Afroep.Main.logout')}
								</ListItemText>
							</ListItem>
						</List>
					</Popover>
					{environmentBox}
				</Toolbar>
			</StyledAppBar>
		)
	}
}

export default TopBar
